const BASE_URL = "/document-flow";


export default [
  {
    path: `${BASE_URL}`,
    name: "document flow",
    component: () => import("@/pages/documentFlow/Index.vue"),
  },  {
    path: `${BASE_URL}/master`,
    name: "master",
    component: () => import("@/pages/documentFlow/master/Index.vue"),
  },  {
    path: `${BASE_URL}/type`,
    name: "type",
    component: () => import("@/pages/documentFlow/type/Index.vue"),
  },  {
    path: `${BASE_URL}/document-attachment`,
    name: "document attachment",
    component: () => import("@/modules/document-attachment/view/DocumentAttachmentPage.vue"),
  }, 
];
